export default function TrustBar() {
  return (
    <section id="trust" className="bg-[#0D0D0D] border-y border-white/8 py-5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-5 md:gap-0">

          {/* Stars + rating */}
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-0.5">
              {[1,2,3,4,5].map(i => (
                <div key={i} className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-star-fill text-[#D4AF37] text-base"></i>
                </div>
              ))}
            </div>
            <div className="flex items-baseline gap-1.5">
              <span className="text-white font-bold text-xl">5.0</span>
              <span className="text-gray-500 text-sm">/ 140+ Reviews</span>
            </div>
          </div>

          <div className="hidden md:block w-px h-7 bg-white/10"></div>

          {/* Statement */}
          <p className="text-gray-400 text-sm text-center">
            Seattle's trusted <strong className="text-white font-semibold">DJ &amp; entertainment company</strong> for weddings, corporate events &amp; school dances
          </p>

          <div className="hidden md:block w-px h-7 bg-white/10"></div>

          {/* Platform badges */}
          <div className="flex items-center gap-6">
            {[
              { label: 'WeddingWire', icon: 'ri-heart-2-line', href: 'https://www.weddingwire.com/biz/bugsie-productions-everett/80d2b012b13a5cab.html' },
              { label: 'Yelp', icon: 'ri-star-line', href: 'https://www.yelp.com/biz/bugsie-productions-everett' },
              { label: 'Facebook', icon: 'ri-facebook-circle-line', href: 'https://www.facebook.com/DJBugsie' },
            ].map(p => (
              <a
                key={p.label}
                href={p.href}
                target="_blank"
                rel="nofollow noreferrer"
                className="flex items-center gap-1.5 text-gray-500 hover:text-[#D4AF37] transition-colors duration-300 cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${p.icon} text-sm`}></i>
                </div>
                <span className="text-xs tracking-widest uppercase font-medium">{p.label}</span>
              </a>
            ))}
          </div>

          <div className="hidden md:block w-px h-7 bg-white/10"></div>

          {/* Insured badge */}
          <div className="flex items-center gap-2 text-gray-500">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shield-check-line text-[#D4AF37] text-sm"></i>
            </div>
            <span className="text-xs tracking-widest uppercase font-medium">Fully Insured</span>
          </div>

        </div>
      </div>
    </section>
  );
}
